// Latin subset only — see styles/_fonts.scss for the @font-face declaration
import '@greenbow/scss'
import './styles/main.scss'

import { createApp } from 'vue'
import App from './App.vue'

createApp(App).mount('#app')
